import {
    Route,
    BrowserRouter as Router,
    Routes,
    Navigate,
} from "react-router-dom";
import { BaseLayoutRoute } from './Router/BaseLayoutRoute';
import { RouteName, routes } from './Router/router';
import { Requests } from "./Views/Requests";
import { Statistics } from "./Views/Statistics";
import { Assemblies } from "./Views/Assemblies";
import { AppProvider, useAppProvider } from "@/Provider/AppProvider";
import { RequestFormView } from "./Views/RequestFormView";
import { PermissionType } from "./Enums/PermissionType";
import { OldRequestPathRedirect } from "./Router/OldRequestPathRedirect";
import { useGlobalErrorHandler } from "./Hooks/useGlobalErrorHandler";
import { companyType, isPublicApp } from "./Utils/environment";
import { Box, Typography, useTheme } from "@mui/material";
import { getCenterStyles, getFlexStyles, getScreenFluidBoxStyles } from "vig-ui-library";
import { FiAlertTriangle } from "react-icons/fi";
import PublicApp from "@/PublicApp";
import { RequestCatalogBuilder } from "./Components/RequestCatalogBuilder";

const App = () => {
    useGlobalErrorHandler();

    if (isPublicApp) {
        return <PublicApp />;
    }

    // Standard mode - show normal app
    if (!companyType) return <CompanyTypeError />

    return (
        <AppProvider>
            <ApplicationRouter />
        </AppProvider>
    );
}

const ApplicationRouter = () => {
    const { permissions } = useAppProvider();

    return <Router future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
    }}>
        <Routes>
            <Route element={<BaseLayoutRoute />}>
                <Route
                    path={routes[RouteName.REQUESTS].pathDefinition}
                    element={<Requests />}
                />

                {permissions.has(PermissionType.READ_STATISTICS) && (
                    <Route
                        path={routes[RouteName.STATISTICS].path}
                        element={<Statistics />}
                    />
                )}

                <Route
                    path={routes[RouteName.REQUEST_CATALOG].path}
                    element={<RequestCatalogBuilder />}
                />

                {permissions.has(PermissionType.READ_ASSEMBLIES) && (
                    <Route
                        path={routes[RouteName.ASSEMBLIES].path}
                        element={<Assemblies />}
                    />
                )}

                <Route
                    path={routes[RouteName.PREVIEW_UPDATE_REQUEST].path}
                    element={<RequestFormView />}
                />

                <Route
                    path={routes[RouteName.ADD_NEW_REQUEST].path}
                    element={<OldRequestPathRedirect />}
                />
            </Route>

            <Route
                path="*"
                element={
                    <Navigate to={routes[RouteName.REQUESTS].path} replace />
                }
            />
        </Routes>
    </Router>
}

const CompanyTypeError = () => {
    const theme = useTheme();

    return <Box sx={{ ...getCenterStyles(), ...getScreenFluidBoxStyles(), ...getFlexStyles("column"), gap: 2 }}>
        <FiAlertTriangle size={32} color={theme.palette.error.main} />
        <Typography variant="h4" color="error">
            "Company type" nie je definovaný.
        </Typography>
    </Box>
}

export default App;